import { useFormContext, useWatch } from 'react-hook-form';
import { CustomFields } from './VisitationLciReportSetupForm';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
} from '@mui/material';

export const IncludedSlidesPresets = () => {
  const formContext = useFormContext<CustomFields>();
  const preset = useWatch<CustomFields, 'includedSlidesPreset'>({
    name: 'includedSlidesPreset',
  });

  const setLciBriefPreset = () => {
    formContext.setValue('includedSlides', {
      overall: {
        overview: false,
        executiveSummary: false,
      },
      footTraffic: {
        titleSlide: false,
        overallResults: true,
        optimizationIndex: false,
        dimensions: false,
      },
      salesAttribution: {
        titleSlide: false,
        summary: false,
        contributionMetrics: false,
        summaryTable: false,
        dimensions: false,
      },
      campaignAnalytics: {
        titleSlide: false,
        audienceProfile: false,
        demographicProfile: false,
        stateAndDmaVisits: false,
        brandLocationVisits: true,
        proximityToHome: true,
        timeToFirstVisitByDay: true,
        visitsByHourOfDay: false,
        visitsByDayOfWeek: false,
        footTrafficOverlap: false,
      },
      appendix: false,
    });
  };

  const setDefaultPreset = () => {
    formContext.resetField('includedSlides');
  };

  const onChange: RadioGroupProps['onChange'] = e => {
    formContext.setValue(
      'includedSlidesPreset',
      e.target.value as CustomFields['includedSlidesPreset']
    );
    if (e.target.value === 'lciBrief') {
      setLciBriefPreset();
    } else {
      setDefaultPreset();
    }
  };

  return (
    <RadioGroup defaultValue="default" value={preset} onChange={onChange}>
      <FormControlLabel value="default" control={<Radio />} label="Default" />
      <FormControlLabel
        value="lciBrief"
        control={<Radio />}
        label="LCI Brief"
      />
    </RadioGroup>
  );
};
